<template>
  <v-dialog
      transition="dialog-bottom-transition"
      width="40%"
      v-model="dialog">

    <template v-slot:activator="{ props }">
      <v-btn
          data-automationId="newPostButton"
          class="newPostButton"
          color="primary"
          v-bind="props"
          @click="dialog = true;"
      ><v-icon icon="mdi-pen" color="white"></v-icon></v-btn>
    </template>
    <template v-slot:default>
      <v-card>
        <v-toolbar
            color="primary"
            title="Create a new Post"
        ></v-toolbar>
        <v-text-field data-automationId="newPostTitle" type="text" label="Title" v-model="title"></v-text-field>
        <v-text-field data-automationId="newPostText" type="content" label="Content" v-model="content"></v-text-field>
        <v-card-actions class="justify-end">
          <v-btn
              data-automationId="newPostCreateButton"
              variant="text"
              @click="createPost();"
          >Create Post</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import {getDatabase, ref, push} from "firebase/database";

export default {
  name: "NewPostPopup",
  data() {
    return {
      title: '',
      content: '',
      dialog: false
    }
  },
  methods: {
    createPost(){
      const currentUser = this.$store.getters.currentUser;
      const newPostData = {
        title: this.title,
        body: this.content,
        starCount: 0,
        author: currentUser.displayName || currentUser.email
      };
      const db = getDatabase();
      const postsRef = ref(db, `posts`);
      push(postsRef, newPostData)
          .then((newPostRef) => {
            console.log('Neuer Post erfolgreich erstellt mit ID:', newPostRef.key);
          })
          .catch((error) => {
            console.error('Fehler beim Erstellen des neuen Posts:', error);
          });



      this.title = "";
      this.content = "";
      this.dialog = false;
    }
  }
}
</script>

<style scoped>
  .newPostButton{
    border-radius: 100%;
    width: 50px;
    height: 50px;
    float: right;
  }
</style>